import {
  CheckCircle,
  XCircle,
  Users,
  TrendingUp,
} from "lucide-react";

const AttendanceStats = ({ data = [] }) => {
  const present = data.filter(d => d.Status === "PRESENT").length;
  const absent = data.filter(d => d.Status === "ABSENT").length;
  const total = data.length;

  const attendanceRate = total
    ? Math.round((present / total) * 100)
    : 0;

  const stats = [
    {
      label: "Present",
      value: present,
      icon: <CheckCircle size={22} />,
      variant: "success",
    },
    {
      label: "Absent",
      value: absent,
      icon: <XCircle size={22} />,
      variant: "danger",
    },
    {
      label: "Total Students",
      value: total,
      icon: <Users size={22} />,
      variant: "info",
    },
    {
      label: "Attendance Rate",
      value: `${attendanceRate}%`,
      icon: <TrendingUp size={22} />,
      variant: "primary",
    },
  ];

 return (
  <>
    {/* STAT CARDS */}
    <div className="attendance-stats-modern">
      {stats.map((s, i) => (
        <div key={i} className={`att-card ${s.variant}`}>
          <div className="att-left">
            <span className="att-label">{s.label}</span>
            <strong className="att-value">{s.value}</strong>
          </div>

          <div className="att-icon">{s.icon}</div>
        </div>
      ))}
    </div>

    {/* ATTENDANCE INDICATOR BELOW */}
    <div className="attendance-summary">
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${attendanceRate}%` }}
        />
      </div>

      <div className="attendance-insight">
        {attendanceRate === 100 && "🎉 Excellent! Full attendance recorded."}
        {attendanceRate >= 75 && attendanceRate < 100 &&
          "✅ Good attendance, but improvement is possible."}
        {attendanceRate < 75 &&
          "⚠️ Attendance is low. Consider follow-ups."}
      </div>
    </div>
  </>
);

};

export default AttendanceStats;
